function preloader() {
    setTimeout(function() {
        $('html, body').css('overflow-y', 'visible');
        $('.async-preloader').css('opacity', '0');
        setTimeout(function() {
            $('.async-preloader').hide();
        }, 300);
    }, 800);
}

$(document).ready(function () {

    preloader();

    $('.filter-form.desktop input[type="checkbox"]').on('change', function() {
        $(".filter-form.desktop").trigger('submit');
        $('.sort-by.desktop select').val($('.sort-by.desktop select option:first').val());
    });

    $('.clear-filter.desktop a').on('click', function(e) {
        e.preventDefault();

        let newUrl = curUrl;

        $('.filter-form.desktop input[type="checkbox"]').prop('checked', false);
        
        $.ajax({
            type: "GET",
            url: newUrl,
            success: function (data) {
                $('.item-found span').html($(data).find('.product-list').find('.products').length);
                if ($(data).find('.product-list').find('.products').length > 0) {
                    $('.product-list').html($(data).find('.product-list').html());
                }
                else {
                    $('.product-list').html('<h3 class="async-title-xxs f-black">No product found.</h3>');
                }
            },
            error: function () {
                console.log("Error occurred while filtering products.");
            },
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, newUrl);
        }
    })

    $(".filter-form.desktop").submit(function (e) {
        e.preventDefault();

        let formData = $(this).serialize();
        let newUrl = curUrl+'?'+formData

        $.ajax({
            type: "GET",
            url: newUrl,
            data: formData,
            success: function (data) {
                $('.item-found span').html($(data).find('.product-list').find('.products').length);
                if ($(data).find('.product-list').find('.products').length > 0) {
                    $('.product-list').html($(data).find('.product-list').html());
                }
                else {
                    $('.product-list').html('<h3 class="async-title-xxs f-black">No product found.</h3>');
                }
            },
            error: function () {
                console.log("Error occurred while filtering products.");
            },
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, newUrl);
        }
    });

    $('.sort-by.desktop select').on('change', function() {
        let currentUrl = window.location.href;
        let url = new URL(currentUrl);

        url.searchParams.set("sort_by", $(this).val());

        let newUrl = url.toString();
        
        $.ajax({
            type: "GET",
            url: newUrl,
            success: function (data) {
                $('.item-found span').html($(data).find('.product-list').find('.products').length);
                if ($(data).find('.product-list').find('.products').length > 0) {
                    $('.product-list').html($(data).find('.product-list').html());
                }
                else {
                    $('.product-list').html('<h3 class="async-title-xxs f-black">No product found.</h3>');
                }
            },
            error: function () {
                console.log("Error occurred while filtering products.");
            },
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, newUrl);
        }
    });

    $('.toggle-filter').on('click', function() {
        $('#async-collections-filter').css('display', 'flex');
        $('html, body').css('overflow-y', 'hidden');
    });

    $('.toggle-filter-close').on('click', function() {
        $('#async-collections-filter').css('display', 'none');
        $('html, body').css('overflow-y', 'visible');
    });

    $('.filter-form.mobile input[type="checkbox"]').on('change', function() {
        $(".filter-form.mobile").trigger('submit');
        $('.sort-by.mobile select').val($('.sort-by.mobile select option:first').val());
    });

    $('.clear-filter.mobile a').on('click', function(e) {
        e.preventDefault();

        let newUrl = curUrl;

        $('.filter-form.mobile input[type="checkbox"]').prop('checked', false);
        
        $.ajax({
            type: "GET",
            url: newUrl,
            success: function (data) {
                $('.item-found span').html($(data).find('.product-list').find('.products').length);
                if ($(data).find('.product-list').find('.products').length > 0) {
                    $('.product-list').html($(data).find('.product-list').html());
                }
                else {
                    $('.product-list').html('<h3 class="async-title-xxs f-black">No product found.</h3>');
                }
            },
            error: function () {
                console.log("Error occurred while filtering products.");
            },
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, newUrl);
        }
    })

    $(".filter-form.mobile").submit(function (e) {
        e.preventDefault();

        let formData = $(this).serialize();
        let newUrl = curUrl+'?'+formData

        $.ajax({
            type: "GET",
            url: newUrl,
            data: formData,
            success: function (data) {
                $('.item-found span').html($(data).find('.product-list').find('.products').length);
                if ($(data).find('.product-list').find('.products').length > 0) {
                    $('.product-list').html($(data).find('.product-list').html());
                }
                else {
                    $('.product-list').html('<h3 class="async-title-xxs f-black">No product found.</h3>');
                }
            },
            error: function () {
                console.log("Error occurred while filtering products.");
            },
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, newUrl);
        }
    });

    $('.sort-by.mobile select').on('change', function() {
        let currentUrl = window.location.href;
        let url = new URL(currentUrl);

        url.searchParams.set("sort_by", $(this).val());

        let newUrl = url.toString();
        
        $.ajax({
            type: "GET",
            url: newUrl,
            success: function (data) {
                $('.item-found span').html($(data).find('.product-list').find('.products').length);
                if ($(data).find('.product-list').find('.products').length > 0) {
                    $('.product-list').html($(data).find('.product-list').html());
                }
                else {
                    $('.product-list').html('<h3 class="async-title-xxs f-black">No product found.</h3>');
                }
            },
            error: function () {
                console.log("Error occurred while filtering products.");
            },
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, newUrl);
        }
    });
});

// form add to cart
$(document).on('submit', '.collection-atc', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart(false);
            openCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});